import { GridRowSelectionModel } from '@mui/x-data-grid-premium'
import React from 'react'
import './style.css'
import MassUpdateTeamTasksComponents from '../MassUpdateComponents/MassUpdateTeamTaskComponents'
import { TasksGridFooterProps } from '../../types'
import { FloatingActionBar } from '../shared'

interface ExtendedTasksGridFooterProps extends TasksGridFooterProps {
  setRowSelectionModel?: React.Dispatch<React.SetStateAction<GridRowSelectionModel>>
}

const TasksGridFooter: React.FC<ExtendedTasksGridFooterProps> = ({
  users,
  selectedData,
  selectedMassData,
  setSelectedMassData,
  isLoading,
  massUpdateData,
  rowSelectionModel,
  setRowSelectionModel,
  rowCount,
  onChange,
  onUpdate,
  onClear,
  onClickDelete,
  onClickMassDelete,
  onDelete,
  onMassDelete,
  isDeleting,
  onClosePopover,
  tasks = [],
  anchorEl,
  context,
  customPosition,
  hasSubtaskSelected,
  onCloseMassDeletePopover,
  isMassDeleteOpen,
}) => {
  const isVisible = rowSelectionModel?.ids?.size > 0

  const handleClose = React.useCallback(() => {
    // Call original close handler if provided
    onClosePopover?.()
    // Clear the selection
    setRowSelectionModel?.({ ids: new Set(), type: 'include' })
  }, [onClosePopover, setRowSelectionModel])

  return (
    <FloatingActionBar visible={isVisible} onClose={handleClose}>
      <MassUpdateTeamTasksComponents
        users={users}
        selectedData={selectedData}
        selectedMassData={selectedMassData}
        setSelectedMassData={setSelectedMassData}
        isLoading={isLoading}
        massUpdateData={massUpdateData}
        rowSelectionModel={rowSelectionModel}
        rowCount={rowCount}
        onChange={onChange}
        onUpdate={onUpdate}
        onClear={onClear}
        onClickDelete={onClickDelete}
        onClickMassDelete={onClickMassDelete}
        onDelete={onDelete}
        onMassDelete={onMassDelete}
        isDeleting={isDeleting}
        onClosePopover={onClosePopover}
        tasks={tasks}
        anchorEl={anchorEl}
        onCloseMassDeletePopover={onCloseMassDeletePopover}
        isMassDeleteOpen={isMassDeleteOpen}
        context={context}
        customPosition={customPosition}
        hasSubtaskSelected={hasSubtaskSelected}
      />
    </FloatingActionBar>
  )
}

export default TasksGridFooter
